/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q3Inputs */

const en_csv_to_json_faq_q3 = /** @type {(inputs: Csv_To_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are all values treated as strings?`)
};

const ko_csv_to_json_faq_q3 = /** @type {(inputs: Csv_To_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 값이 문자열로 처리되나요?`)
};

const ja_csv_to_json_faq_q3 = /** @type {(inputs: Csv_To_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての値は文字列として扱われますか？`)
};

/**
* | output |
* | --- |
* | "Are all values treated as strings?" |
*
* @param {Csv_To_Json_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q3 = /** @type {((inputs?: Csv_To_Json_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q3(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q3(inputs)
	return ja_csv_to_json_faq_q3(inputs)
});